import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import WithdrawFromWallet from './WithdrawFromWallet.vue';
import { Wallet, Beneficiary, Transaction } from 'ah-api-gateways';
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawFromWalletModal',
  props: {
    wallet: null,
    transaction: { default: null },
    hideButton: { type: [Boolean, String], default: false },
    selfBeneficiary: { type: [Boolean, String], default: false },
    targetBeneficiary: null
  },
  emits: ["withdraw-succeded"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'withdraw-succeded', value: void): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { wallet: Wallet, transaction: Transaction | null, hideButton: boolean | string, selfBeneficiary: boolean | string, targetBeneficiary?: Beneficiary };

const withdrawFromWalletModal = ref<InstanceType<typeof BModal> | null>(null);





function show() {
  withdrawFromWalletModal.value?.show();
}

function hide() {
  withdrawFromWalletModal.value?.hide();
}

function onWithdrawSucceeded() {
  emit('withdraw-succeded');
  hide();
}

const title = computed(() => {
  if (props.selfBeneficiary !== false) {
    return `Withdraw money from ${props.wallet.currency} wallet`;
  }
  return `${props.transaction ? 'Amend' : 'Make'} Payment`;
});

return { __sfc: true,withdrawFromWalletModal, props, emit, show, hide, onWithdrawSucceeded, title, BModal, WithdrawFromWallet }
}

})